module.exports = __webpack_public_path__ + "img/CC-LogoMark-white.0920a4d1.png";